import { Component, OnInit, OnDestroy } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { environment } from 'src/environments/environment';
import { KeycloakService } from 'keycloak-angular';
@Component({
  selector: 'app-chat',
  imports: [],
  templateUrl: './chat.component.html',
  styleUrl: './chat.component.scss',
  standalone: true,
})
export class ChatComponent implements OnInit, OnDestroy {
  private baseUrl = environment.chat;
  public url: SafeResourceUrl;
  public isAuthenticated = false;

  private readonly STORAGE_KEY = 'chat_remaining_messages';
  public totalMessages = 5;
  public remainingMessages: number;
  private boundHandleMessage: (event: MessageEvent) => void;

  constructor(
    private sanitizer: DomSanitizer,
    private keycloakService: KeycloakService,
  ) {
    this.url = this.sanitizer.bypassSecurityTrustResourceUrl(this.baseUrl);
    this.remainingMessages = this.loadRemainingMessages();
    this.boundHandleMessage = this.handleMessage.bind(this);
  }

  ngOnInit() {
    this.isAuthenticated = this.keycloakService.isLoggedIn();
    window.addEventListener('message', this.boundHandleMessage);
  }

  ngOnDestroy() {
    window.removeEventListener('message', this.boundHandleMessage);
  }

  private loadRemainingMessages(): number {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored ? parseInt(stored, 10) : this.totalMessages;
  }

  private saveRemainingMessages() {
    localStorage.setItem(this.STORAGE_KEY, this.remainingMessages.toString());
  }

  private handleMessage(event: MessageEvent) {
    console.log('Received message:', event.data);
    if (event.data.channel === 'newMessage') {
      console.log('New message sent:', event.data.message);
      if (this.remainingMessages > 0) {
        this.remainingMessages--;
        this.saveRemainingMessages();
      }
    }
  }

  get hasAccessToChat(): boolean {
    return this.isAuthenticated || this.remainingMessages > 0;
  }

  login() {
    this.keycloakService.login();
  }
}
